import {
  Divider,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@cencosud-cencommerce/paris-uikit';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import digitalGiftCardImage from '@/modules/perseo-billing/assets/images/find-digital-gift-card.png';
import physicalGiftCardImage from '@/modules/perseo-billing/assets/images/find-physical-gift-card.png';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import { setIsGiftCardModalFindItOpen } from '@/modules/perseo-billing/store/slices/billing';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks';

export const ModalFindGiftCard = () => {
  const dispatch = useAppDispatch();
  const { isGiftCardModalFindItOpen } = useAppSelector(
    (state) => state.billing
  );
  const isMobile = useMediaQuery('lg');
  const { linkOkGiftCardFindItGtm } = useGtmBillingProduct();

  const handleClose = () => {
    dispatch(setIsGiftCardModalFindItOpen(false));
    linkOkGiftCardFindItGtm();
  };

  return (
    <Modal isOpen={isGiftCardModalFindItOpen} onClose={handleClose} size="md">
      <ModalHeader
        icon={{
          fill: 'primary-500',
          name: 'info-circle'
        }}
        onClose={handleClose}
        title="¿Dónde lo encuentro?"
      />

      <ModalBody>
        <div className="co-flex co-flex-col co-h-full co-gap-6 co-px-4 co-pt-24px co-justify-between lg:co-flex-row lg:co-justify-center">
          <div className="co-flex co-flex-col co-gap-y-32px lg:co-w-1/2">
            <Text
              className="co-text-[16px] co-inline"
              variant="body1"
              element="p"
            >
              <Text
                className="co-font-bold co-inline co-text-[16px]"
                weight={600}
                variant="body1"
                element="p"
              >
                {'Online: '}
              </Text>
              como PDF adjunto en el correo, junto con tu clave.
            </Text>
            <img
              src={digitalGiftCardImage}
              alt={'product'}
              width={221}
              height={153}
              className="co-self-center"
            />
          </div>

          <Divider
            orientation={isMobile ? 'horizontal' : 'vertical'}
            className={isMobile ? '' : 'co-h-auto'}
          />

          <div className="co-flex co-flex-col co-gap-4 lg:co-w-1/2">
            <Text
              className="co-text-[16px]"
              weight={600}
              variant="body1"
              element="p"
            >
              Física:
            </Text>
            <img
              src={physicalGiftCardImage}
              alt={'product'}
              width={283}
              height={120}
              className="co-self-center"
            />
          </div>
        </div>
      </ModalBody>

      <ModalFooter
        buttonsAlign="vertical"
        primaryButton={{
          label: 'Entendido',
          onClick: handleClose
        }}
      />
    </Modal>
  );
};
